import _ from "lodash";
import React from "react";
import { InputGroup, Input, Dropdown } from "rsuite";
import { MaskInput } from "../formfields/MaskInput";
import { DatePickerComponent } from "../formfields/DatePicker";

export class FilterPopover extends React.Component<any, {}> {
    public state = {
        value: typeof this.props.value === "string" ? this.props.value : this.props.field.type === "checkbox" ? "Todos" : "",
        advanced: this.props.advanced,
        operator: this.props.operator,
    };

    onChange = (value: string) => {
        this.setState({ value });

        if (this.props.onChange) {
            if (value == '') {
                this.props.onChange();
            } else {
                this.props.onChange(value, this.state.advanced === true ? this.state.operator : "like");
            }
        }
    };

    onDateInputChange = (value: string) => {
        // Remove todos os caracteres não numéricos exceto "/"
        let sanitizedValue = value.replace(/[^0-9/]/g, '');

        // Limitar a string a 22 caracteres (DD/MM/YYYY - DD/MM/YYYY)
        sanitizedValue = sanitizedValue.slice(0, 20);

        // Adiciona automaticamente as barras e o traço para a formatação de data
        if (sanitizedValue.length > 2 && sanitizedValue[2] !== '/') {
            sanitizedValue = sanitizedValue.slice(0, 2) + '/' + sanitizedValue.slice(2);
        }
        if (sanitizedValue.length > 5 && sanitizedValue[5] !== '/') {
            sanitizedValue = sanitizedValue.slice(0, 5) + '/' + sanitizedValue.slice(5);
        }
        if (sanitizedValue.length > 10 && sanitizedValue[10] !== ' ') {
            sanitizedValue = sanitizedValue.slice(0, 10) + ' - ' + sanitizedValue.slice(10);
        }
        if (sanitizedValue.length > 15 && sanitizedValue[15] !== '/') {
            sanitizedValue = sanitizedValue.slice(0, 15) + '/' + sanitizedValue.slice(15);
        }
        if (sanitizedValue.length > 18 && sanitizedValue[18] !== '/') {
            sanitizedValue = sanitizedValue.slice(0, 18) + '/' + sanitizedValue.slice(18);
        }

        // Atualiza o estado com o valor formatado
        this.setState({ value: sanitizedValue });

        if (this.props.onChange) {
            this.props.onChange(sanitizedValue);
        }
    };

    onExit = () => {
        if (this.state.value == '') {
            this.props.onChange();
        }else{
            this.props.onChange(this.state.value, this.state.advanced === true ? this.state.operator : "like");
        }

        if (this.props.onExit) {
            this.props.onExit();
        }
    };

    onClick = () => {
        this.setState({ value: "" });
        if (this.props.onChange) {
            this.props.onChange("");
        }
    };

    onSelect = (value: string | boolean) => {
        this.onChange(String(value));
    };

    onChangeOperator = (operator: string) => {
        this.setState({ operator });
        if (this.props.onChange) {
            this.props.onChange(this.state.value, this.state.advanced === true ? operator : "like");
        }
    };

    public types: any = {
        like: "Contém",
        notlike: "Não contém",
        equal: "Igual",
        eq: "Mesmo que",
        gt: "Maior que",
        lt: "Menor que",
        gte: "Maior ou igual",
        lte: "Menor ou igual",
        startswith: "Começa com",
        endswith: "Termina com",
        gtstrlen: "Comprimento maior que",
        ltstrlen: "Comprimento menor que",
        eqstrlen: "Comprimento igual a",
        between: "Entre",
    };

    getValuesFromAllowedTypes(types: string[]) {
        var output: any = [];
        var inverted = _.invert(this.types);

        for (var i in types) {
            if (inverted[types[i]]) {
                output.push({ value: inverted[types[i]], name: types[i] });
            }
        }
        return output;
    }

    allowedTypes() {
        var type = this.props.field?.type ?? "text";

        if (this.props.isIndex) {
            type = 'number';
        }
        switch (type) {
            case "numeric":
            case "number":
                return ["Mesmo que", "Maior que", "Menor que", "Maior ou igual", "Menor ou igual"];
            case "select":
                return ["Contém", "Não contém", "Igual", "Começa com", "Termina com", "Comprimento menor que", "Comprimento maior que", "Comprimento igual a"];
            case "checkbox":
                return ["Contém", "Não contém", "Igual", "Começa com", "Termina com"];
            case "text":
                return ["Contém", "Não contém", "Igual", "Começa com", "Termina com", "Comprimento menor que", "Comprimento maior que", "Comprimento igual a"];
            case "datepicker":
                return ["Entre", "Maior que", "Menor que"];
            default:
                return ["Contém", "Não contém", "Igual", "Maior que", "Menor que", "Maior ou igual", "Menor ou igual", "Começa com", "Termina com"];
        }
    }

    render() {
        // if (this.props.field.name.includes('created')) {
        //     const { field } = this.props;
        //     return (
        //         <>
        //             <InputGroup>
        //                 <DatePickerComponent
        //                     value={new Date()}
        //                     onChange={this.onChange}
        //                 />
        //                 {this.state.value.length > 0 && (
        //                     <InputGroup.Button onClick={this.onClick}>
        //                         <i className="fas fa-times"></i>
        //                     </InputGroup.Button>
        //                 )}
        //             </InputGroup>
        //         </>
        //     )
        // }

        if (this.state.advanced === true && this.props.hasAdvanced !== false) {
            const operators = this.getValuesFromAllowedTypes(this.allowedTypes());
            const typeByOperator: any = {
                gt: "number",
                lt: "number",
                gte: "number",
                lte: "number",
                gtstrlen: "number",
                ltstrlen: "number",
                eqstrlen: "number",
                between: "text"
            };

            const selectedOperatorType: any = typeByOperator[this.state.operator];

            return (
                <>
                    {(this.props.field === undefined || (this.props.field !== undefined && this.props.field.type !== "checkbox")) && (
                        <InputGroup>
                            <div className="rs-input-suffix">
                                <Dropdown title={this.types[this.state.operator] ?? "Contém"}>
                                    {operators.map((item: any) => {
                                        return (
                                            <Dropdown.Item key={item.value} active={this.state.operator === item.value} onSelect={() => this.onChangeOperator(item.value)}>
                                                {item.name}
                                            </Dropdown.Item>
                                        );
                                    })}
                                </Dropdown>
                            </div>
                            <Input
                                type={selectedOperatorType}
                                value={this.state.value}
                                onPressEnter={this.onExit}
                                onChange={selectedOperatorType === "text" && this.state.operator === "between"
                                    ? this.onDateInputChange
                                    : (value: string) => this.onChange(value)
                                }
                            />
                            {this.state.value.length > 0 && (
                                <InputGroup.Button onClick={this.onClick}>
                                    <i className="fas fa-times"></i>
                                </InputGroup.Button>
                            )}
                        </InputGroup>
                    )}
                    {this.props.field !== undefined && this.props.field.type === "checkbox" && (
                        <InputGroup>
                            <Dropdown title={this.state.value === "" ? "Todos" : this.state.value}>
                                <Dropdown.Item active={this.state.value === "Todos" || this.state.value === ""} onSelect={() => this.onSelect("Todos")}>
                                    {"Todos"}
                                </Dropdown.Item>
                                <Dropdown.Item active={this.state.value === "Não"} onSelect={() => this.onSelect("Não")}>
                                    {"Não"}
                                </Dropdown.Item>
                                <Dropdown.Item active={this.state.value === "Sim"} onSelect={() => this.onSelect("Sim")}>
                                    {"Sim"}
                                </Dropdown.Item>
                            </Dropdown>
                            {this.state.value.length > 0 && (
                                <InputGroup.Button onClick={this.onClick}>
                                    <i className="fas fa-times"></i>
                                </InputGroup.Button>
                            )}
                        </InputGroup>
                    )}
                    {this.props.hasAdvanced !== false && (
                        <div className="rs-meta" onClick={this.props.onToggleMode}>
                            Básico...
                        </div>
                    )}
                </>
            );
        }
        return (
            <>
                <InputGroup>
                    <Input value={this.state.value} onPressEnter={this.onExit} onChange={(value: string) => this.onChange(value.toString())} />
                    {this.state.value.length > 0 && (
                        <InputGroup.Button onClick={this.onClick}>
                            <i className="fas fa-times"></i>
                        </InputGroup.Button>
                    )}
                </InputGroup>
                {this.props.hasAdvanced !== false && (
                    <div className="rs-meta" onClick={this.props.onToggleMode}>
                        Avançado...
                    </div>
                )}
            </>
        );
    }
}
